// @ts-nocheck
import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {userSelector} from '@stencil/user-reducer';
import {getter, setter} from '@stencil/client-side-storage';
import getDaysBetweenTwoDates from '@stencil/date-utils/src/getDaysBetweenTwoDates';
import isDateEqual from '@stencil/date-utils/src/isDateEqual';
import {
  getFromSessionStorage,
  saveToSessionStorage,
} from '@stencil/hotels-utils/src/client-storage';
import {pushga} from '@stencil/ga-utils';
import {gaConfig} from '@stencil/hotels-config';
import {showLoginPopOverEvent} from '@growth/dweb-header';
import domEventEmitter from '@growth/dom-event-emitter';
import {DOM_EVENT_NAME} from '@growth/dweb-header/events';

const {detailsPageClickEventCategoryName} = gaConfig;

const LoginBlocker = ({source}) => {
  const dispatch = useDispatch();

  const {isLoggedIn} = useSelector(userSelector);

  const [flowType, setFlowType] = useState(null);
  const showLoginBlocker = !isLoggedIn;

  const isLoginPopupViewed = 'isLoginPopUpViewed';
  const hotelDetailsVisitedKey = 'hotels-details-visited';
  const keyName = 'isNewUserLoginNow';

  useEffect(() => {
    const userLastVisitedDate = getter(keyName);
    let isNotViewed = false;
    let isViewedInLocalStorage = getter(isLoginPopupViewed) || 0;
    let diff = isViewedInLocalStorage
      ? getDaysBetweenTwoDates(new Date(), new Date(isViewedInLocalStorage))
      : 0;

    if (!isViewedInLocalStorage || (diff && diff >= 7)) {
      isNotViewed = true;
    }
    /**
     * Check if isNewUserLoginNow is set in Local Storage.
     * If No then set isNewUserLoginNow key in Local Storage and
     * also if details page then set count 1.
     * Else check if Blocker Popup is viewed in session or not and
     * Blocker Popup is already open then move to updateLoginBlockerVisibility function.
     */

    if (!userLastVisitedDate) {
      setter(keyName, new Date());
      if (source == 'details') {
        saveToSessionStorage(hotelDetailsVisitedKey, 1 + '');
      }
    } else if (isNotViewed) {
      updateLoginBlockerVisibility(userLastVisitedDate);
    }
  }, []);

  const saveLoginPopupViewed = () => {
    let isViewedInLocalStorage = getter(isLoginPopupViewed);
    let diff = isViewedInLocalStorage
      ? getDaysBetweenTwoDates(new Date(), new Date(isViewedInLocalStorage))
      : 0;
    if (!isViewedInLocalStorage || (diff && diff >= 7)) {
      setter(isLoginPopupViewed, new Date());
    }
  };

  const showLoginPopup = (conditionType, page) => {
    if (showLoginBlocker) {
      let validConditionArr = ['repeat', 'new', 'gallery'];
      if (validConditionArr.indexOf(conditionType) > -1) {
        if (page == 'srp') {
          domEventEmitter.emit(DOM_EVENT_NAME.START_LOGIN_FLOW);
        } else if (page == 'details' || page == 'gallery') {
          showLoginPopOverEvent();
        }
      }
    }
  };

  const updateLoginBlockerVisibility = val => {
    let getDaysDiff = getDaysBetweenTwoDates(new Date(), new Date(val));
    /**
     * This checks if diff between current date and date saved in Local storage
     * is greater than or equal to 30 then set Current Date in Local storage.
     */
    if (getDaysDiff >= 30) {
      setter(keyName, new Date());
      getDaysDiff = 0;
    }
    const isCurrentDate = isDateEqual(new Date(), new Date(val));

    const repeatUserCondition = getDaysDiff >= 1 && getDaysDiff < 30;
    // const hotelDetailGalleryCondition = source == 'gallery' && !Boolean(isGalleryBlockerViewed);
    let newUserCondition = false;
    if (source == 'details') {
      const hotelDetailsVisitCount = Number(getFromSessionStorage(hotelDetailsVisitedKey) || 0) + 1;
      newUserCondition = isCurrentDate && hotelDetailsVisitCount >= 2;
      saveToSessionStorage(hotelDetailsVisitedKey, hotelDetailsVisitCount + '');
    }
    let type = '';
    if (repeatUserCondition) {
      type = 'repeat';
    } else if (newUserCondition) {
      type = 'new';
    }
    // else if (hotelDetailGalleryCondition) {
    //   type = 'gallery';
    //   saveToSessionStorage(hotelDetailsGalleryVisitedKey, '1');
    // }
    if (type) {
      showLoginPopup(type, source);
      saveLoginPopupViewed();
    }
  };
  return null;
};
export default LoginBlocker;
